export interface SiteBrandConfig {
  projectName: string
  domainName: string
}

export const siteBrand: SiteBrandConfig = {
  projectName: 'Zippity',
  domainName: 'zippity.app',
}

const appDomain = import.meta.env.VITE_APP_DOMAIN ?? 'app.zippity.app'
const appProtocol = appDomain.startsWith('localhost') ? 'http' : 'https'
const appOrigin = `${appProtocol}://${appDomain}`

export const appUrl = {
  signUp: `${appOrigin}/auth/sign-up`,
  signIn: `${appOrigin}/auth/sign-in`,
}
